import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { company } from "../data/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/hardscaping", label: "Hardscaping" },
  { to: "/snow-removal", label: "Snow Removal" },
  { to: "/lawn-maintenance", label: "Lawn Maintenance" },
  { to: "/outdoor-kitchens", label: "Outdoor Kitchens" },
  { to: "/gallery", label: "Gallery" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-bone/85 border-b border-ink/10" : "bg-transparent"
      }`}
    >
      <div className="container-fl flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif text-2xl md:text-[28px] text-ink tracking-tight">
            Fresh Landscape
          </span>
          <span className="overline text-[10px] mt-0.5">Group · Alberta</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-forest" : "text-moss hover:text-forest"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-5">
          <a
            href={company.phoneHref}
            data-testid="nav-phone"
            className="flex items-center gap-2 text-sm font-medium text-ink hover:text-clay transition-colors"
          >
            <Phone size={16} strokeWidth={1.5} /> {company.phone}
          </a>
          <Link to="/contact" data-testid="nav-quote-btn" className="btn-primary py-3 px-6 text-sm">
            Get a Free Quote
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-ink"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-bone border-t border-ink/10">
          <div className="container-fl py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className="text-base font-medium text-ink py-1"
                data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn-primary mt-2" data-testid="mobile-quote-btn">
              Get a Free Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
